export interface Category {
  id: string;
  name: string;
  icon: string;
  description: string;
  gameCount: number;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    id: 'slot',
    name: '老虎机',
    icon: 'ri-game-line',
    description: '经典与创新老虎机游戏，多种主题、高额奖池，带给您无穷的旋转乐趣与惊喜大奖体验。',
    gameCount: 328,
    imageSeq: 'category-slot-01',
  },
  {
    id: 'table',
    name: '桌面游戏',
    icon: 'ri-vip-crown-line',
    description: '百家乐、轮盘、骰宝等经典桌面游戏，真实还原澳门赌场氛围，专业荷官为您服务。',
    gameCount: 156,
    imageSeq: 'category-table-01',
  },
  {
    id: 'poker',
    name: '扑克竞技',
    icon: 'ri-gamepad-line',
    description: '德州扑克、斗地主等热门扑克游戏，与全球玩家实时对战，展现您的牌技与策略。',
    gameCount: 89,
    imageSeq: 'category-poker-01',
  },
  {
    id: 'live',
    name: '真人视讯',
    icon: 'ri-live-line',
    description: '高清真人视讯直播，专业荷官实时互动，身临其境感受澳门顶级娱乐场的奢华体验。',
    gameCount: 64,
    imageSeq: 'category-live-01',
  },
  {
    id: 'lottery',
    name: '彩票游戏',
    icon: 'ri-ticket-line',
    description: '时时彩、六合彩等多种彩票玩法，高赔率、快速开奖，让您随时随地把握幸运机会。',
    gameCount: 42,
    imageSeq: 'category-lottery-01',
  },
  {
    id: 'sport',
    name: '体育竞技',
    icon: 'ri-football-line',
    description: '覆盖全球各大体育赛事，足球、篮球、网球等实时投注，赛事直播与数据分析一应俱全。',
    gameCount: 215,
    imageSeq: 'category-sport-01',
  },
];